module.exports = __webpack_public_path__ + "img/制御工学3_6.5636d8bc.png";